<nb-card>
	<nb-card-header>{{
		(project
			? 'ORGANIZATIONS_PAGE.EDIT.EDIT_PROJECT'
			: 'ORGANIZATIONS_PAGE.EDIT.NEW_PROJECT'
		) | translate
	}}</nb-card-header>
	<nb-card-body>
		<form [formGroup]="form" *ngIf="form">
			<nb-tabset>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.MAIN' | translate">
					<div class="row">
						<div class="form-group col-4">
							<label for="name" class="label">{{
								'FORM.PLACEHOLDERS.NAME' | translate
							}}</label>
							<input
								type="text"
								#name
								nbInput
								fullWidth
								formControlName="name"
								placeholder="{{
									'FORM.PLACEHOLDERS.NAME' | translate
								}}"
								id="name"
								[status]="
									isInvalidControl('name') ? 'danger' : 'basic'
								"
							/>
						</div>
						<div class="form-group col-4">
							<label for="code" class="label">{{
								'FORM.PLACEHOLDERS.CODE' | translate
							}}</label>
							<input
								type="text"
								#code
								nbInput
								fullWidth
								formControlName="code"
								placeholder="{{
									'FORM.PLACEHOLDERS.CODE' | translate
								}}"
								id="code"
							/>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-4">
							<label for="projectUrl" class="label">
								{{ 'FORM.LABELS.PROJECT_URL' | translate }}
							</label>
							<input
								type="text"
								nbInput
								fullWidth
								placeholder="{{
									'FORM.PLACEHOLDERS.PROJECT_URL' | translate
								}}"
								id="projectUrl"
								formControlName="projectUrl"
								[status]="
									isInvalidControl('projectUrl') ? 'danger' : 'basic'
								"
							/>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-4">
							<label for="owner" class="label">{{
								'FORM.PLACEHOLDERS.OWNER' | translate
							}}</label>
							<nb-select
								fullWidth
								placeholder="{{
									'FORM.PLACEHOLDERS.OWNER' | translate
								}}"
								formControlName="owner"
								id="owner"
								(selectedChange)="changeProjectOwner($event)"
							>
								<nb-option
									*ngFor="let owner of owners"
									[value]="owner"
									>{{ 'SM_TABLE.' + owner | translate }}
								</nb-option>
							</nb-select>
						</div>
						<div class="form-group col-4">
							<label for="organizationContacts" class="label">
								{{ 'FORM.LABELS.CLIENTS' | translate }}
							</label>
							<ng-select
								[addTag]="addNewOrganizationContact"
								[items]="organizationContacts"
								bindLabel="name"
								[searchable]="true"
								#organizationContact
								formControlName="organizationContact"
								placeholder="{{
									'FORM.PLACEHOLDERS.CLIENTS' | translate
								}}"
								appendTo="body"
							>
							</ng-select>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-4">
							<ga-employee-multi-select
								[selectedEmployeeIds]="selectedEmployeeIds"
								[allEmployees]="employees"
								(selectedChange)="onMembersSelected($event)"
								id="add-remove-emploees"
							>
							</ga-employee-multi-select>
						</div>
					</div>
					<div class="row">
						<div class="form-group col-4">
							<label for="start-date-project" class="label">{{
								'FORM.PLACEHOLDERS.START_DATE_PROJECT'
									| translate
							}}</label>
							<input
								[nbDatepicker]="startDate"
								nbInput
								fullWidth
								formControlName="startDate"
								placeholder="{{
									'FORM.PLACEHOLDERS.START_DATE_PROJECT'
										| translate
								}}"
								id="start-date-project"
							/>
							<nb-datepicker #startDate></nb-datepicker>
						</div>
						<div class="form-group col-4">
							<label for="end-date-project" class="label">{{
								'FORM.PLACEHOLDERS.END_DATE_PROJECT' | translate
							}}</label>
							<input
								[nbDatepicker]="endDate"
								nbInput
								fullWidth
								formControlName="endDate"
								placeholder="{{
									'FORM.PLACEHOLDERS.END_DATE_PROJECT'
										| translate
								}}"
								id="end-date-project"
							/>
							<nb-datepicker #endDate></nb-datepicker>
						</div>
					</div>
				</nb-tab>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.DESCRIPTION' | translate">
					<div class="row">
						<div class="col-8">
							<label
								for="description"
								class="label"
								[innerHtml]="'FORM.PLACEHOLDERS.DESCRIPTION' | translate"
							></label>
							<ckeditor formControlName="description" [config]="ckConfig"></ckeditor>
						</div>
						<div class="col-4">
							<ga-tags-color-input
								[selectedTags]="tags"
								(selectedTagsEvent)="selectedTagsEvent($event)"
								[isOrgLevel]="true"
							>
							</ga-tags-color-input>
						</div>
					</div>
				</nb-tab>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.BILLING' | translate">
					<div class="row">
						<div class="form-group col-4">
							<label for="billing" class="label">{{
								'FORM.PLACEHOLDERS.BILLING' | translate
							}}</label>
							<nb-select
								fullWidth
								placeholder="{{
									'FORM.PLACEHOLDERS.BILLING' | translate
								}}"
								formControlName="billing"
								id="billing"
							>
								<nb-option
									*ngFor="let billing of billings"
									[value]="billing"
								>
									{{ 'SM_TABLE.' + billing | translate }}
								</nb-option>
							</nb-select>
						</div>
						<div class="col-4">
							<ga-currency
								formControlName="currency"
								(optionChange)="currencyChanged($event)"
							>
							</ga-currency>
						</div>
					</div>
				</nb-tab>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.BUDGET' | translate">
					<div class="row">
						<div class="form-group col-4">
							<label class="label">{{
								'FORM.PLACEHOLDERS.BUDGET_TYPE' | translate
							}}</label>
							<nb-select
								fullWidth
								[placeholder]="
									'FORM.PLACEHOLDERS.BUDGET_TYPE' | translate
								"
								formControlName="budgetType"
							>
								<nb-option
									*ngFor="
										let budgetType of OrganizationProjectBudgetTypeEnum
											| keyvalue
									"
									[value]="budgetType.value"
								>
									{{ budgetType.value | titlecase }}
								</nb-option>
							</nb-select>
						</div>
						<div
							class="form-group col-4"
							*ngIf="
								form.controls.budgetType.value ===
								OrganizationProjectBudgetTypeEnum.HOURS
							"
						>
							<label class="label">{{
								'FORM.PLACEHOLDERS.HOURS' | translate
							}}</label>
							<input
								nbInput
								type="number"
								fullWidth
								formControlName="budget"
								[placeholder]="
									'FORM.PLACEHOLDERS.HOURS' | translate
								"
							/>
						</div>
						<div
							class="form-group col-4"
							*ngIf="
								form.controls.budgetType.value ===
								OrganizationProjectBudgetTypeEnum.COST
							"
						>
							<label class="label">{{
								'FORM.PLACEHOLDERS.COST' | translate
							}}</label>
							<input
								nbInput
								type="number"
								fullWidth
								formControlName="budget"
								[placeholder]="
									'FORM.PLACEHOLDERS.COST' | translate
								"
							/>
						</div>
					</div>
				</nb-tab>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.OPEN_SOURCE' | translate">
					<div class="row">
						<div class="col-4 d-flex align-items-center">
							<nb-toggle
								class="project-toggle"
								labelPosition="start"
								status="basic"
								[checked]="openSource"
								(checkedChange)="toggleOpenSource($event)"
								formControlName="openSource"
							>
								{{
									'FORM.LABELS.IS_PROJECT_OPEN_SOURCE'
										| translate
								}}
							</nb-toggle>
						</div>
						<div *ngIf="openSource" class="form-group col-4">
							<label for="openSourceProjectUrl" class="label">
								{{
									'FORM.LABELS.OPEN_SOURCE_PROJECT_URL'
										| translate
								}}
							</label>
							<input
								type="text"
								nbInput
								fullWidth
								placeholder="https://github.com/..."
								id="openSourceProjectUrl"
								formControlName="openSourceProjectUrl"
								[status]="
									isInvalidControl('openSourceProjectUrl') ? 'danger' : 'basic'
								"
							/>
						</div>
					</div>
				</nb-tab>
				<nb-tab [tabTitle]="'ORGANIZATIONS_PAGE.SETTINGS' | translate">
					<div class="row">
						<div class="form-group col-3">
							<label for="color" class="label">{{
								'FORM.PLACEHOLDERS.COLOR' | translate
							}}</label>

							<input
								type="text"
								nbInput
								fullWidth
								formControlName="color"
								placeholder="{{
									'FORM.PLACEHOLDERS.COLOR' | translate
								}}"
								id="color"
								[colorPicker]="form.get('color').value"
								[style.background]="form.get('color').value"
								[value]="form.get('color').value"
								(colorPickerChange)="
									form.get('color').setValue($event)
								"
							/>
						</div>
						<div class="form-group col-3">
							<label for="owner" class="label">{{
								'FORM.PLACEHOLDERS.TASK_VIEW_MODE' | translate
							}}</label>
							<nb-select
								fullWidth
								placeholder="{{
									'FORM.PLACEHOLDERS.TASK_VIEW_MODE'
										| translate
								}}"
								formControlName="taskViewMode"
								id="taskViewMode"
							>
								<nb-option
									*ngFor="let mode of taskViewModeTypes"
									[value]="mode"
									>{{ mode }}
								</nb-option>
							</nb-select>
						</div>
						<div class="col-2 d-flex align-items-center">
							<nb-toggle
								#public
								class="project-toggle"
								labelPosition="start"
								status="basic"
								[checked]="public"
								formControlName="public"
								(checkedChange)="togglePublic($event)"
								>{{
									'FORM.PLACEHOLDERS.SWITCH_PROJECT_STATE'
										| translate
								}}</nb-toggle
							>
						</div>
						<div class="col-2 d-flex align-items-center">
							<nb-toggle
								#billable
								class="project-toggle"
								labelPosition="start"
								status="basic"
								[checked]="billable"
								formControlName="billable"
								(checkedChange)="toggleBillable($event)"
								>{{
									'FORM.PLACEHOLDERS.BILLABLE' | translate
								}}</nb-toggle
							>
						</div>
					</div>
				</nb-tab>
			</nb-tabset>
		</form>
		<div
			class="form-group"
			style="display: flex; justify-content: flex-end"
		>
			<button class="mr-2" (click)="cancel()" nbButton status="danger">
				{{ 'BUTTONS.CANCEL' | translate }}
			</button>
			<button
				class="mr-2"
				(click)="submitForm()"
				nbButton
				status="success"
				[disabled]="!form.valid"
				[attr.aria-invalid]="
					form.controls.name.invalid && form.controls.name.touched
						? true
						: null
				"
			>
				{{ 'BUTTONS.SAVE' | translate }}
			</button>
			<button
				*ngIf="form.controls['taskViewMode'].value === 'SPRINT'"
				nbButton
				class="float-right"
				status="success"
				(click)="openTasksSettings()"
			>
				{{ 'BUTTONS.MANAGE_SPRINTS' | translate }}
			</button>
		</div>
	</nb-card-body>
</nb-card>

<div *ngIf="form?.controls?.taskViewMode?.value == TaskListTypeEnum.SPRINT">
	<ngx-tasks-sprint-settings-view
		[project]="project"
	></ngx-tasks-sprint-settings-view>
</div>
